import { useEffect, useState } from 'react';

export default function ServicesSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 768) { // Only on desktop
        setScrollY(window.scrollY);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Business Consulting',
      description: 'Strategic guidance and expert advice to accelerate your business growth and optimize operations.',
      features: ['Strategic Planning', 'Market Analysis', 'Process Optimization', 'Growth Strategies'],
      color: 'blue'
    },
    {
      icon: 'ri-brain-line',
      title: 'Trading Psychology',
      description: 'Master the mental game of trading with our specialized psychology coaching and mindset training.',
      features: ['Mindset Coaching', 'Risk Management', 'Emotional Control', 'Performance Analysis'],
      color: 'violet'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud & VPS Hosting',
      description: 'Reliable, scalable cloud infrastructure and VPS solutions for your digital operations.',
      features: ['Cloud Migration', 'VPS Setup', 'Server Management', '24/7 Support'],
      color: 'blue'
    },
    {
      icon: 'ri-shield-line',
      title: 'Secure Storage',
      description: 'Enterprise-grade secure storage solutions with advanced encryption and backup systems.',
      features: ['Data Encryption', 'Automated Backups', 'Access Control', 'Compliance Ready'],
      color: 'violet'
    },
    {
      icon: 'ri-links-line',
      title: 'Blockchain Networks',
      description: 'Build and deploy on decentralized networks with our blockchain infrastructure expertise.',
      features: ['Network Setup', 'Smart Contracts', 'DApp Development', 'Token Economics'],
      color: 'blue'
    },
    {
      icon: 'ri-shield-keyhole-line',
      title: 'VPN & Node Services',
      description: 'Secure networking solutions and node management for decentralized infrastructure.',
      features: ['VPN Setup', 'Node Management', 'Network Security', 'Performance Monitoring'],
      color: 'violet'
    }
  ];

  return (
    <section 
      id="services" 
      className="py-20 relative overflow-hidden"
      style={{
        backgroundColor: '#0D0F14',
        backgroundImage: `linear-gradient(rgba(10, 10, 10, 0.6), rgba(10, 10, 10, 0.6)), url('https://public.readdy.ai/ai/img_res/06a565bce0bad2f4f8b96f67e87a95e3.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-violet-900/10 to-blue-900/10"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our <span className="bg-gradient-to-r from-blue-400 to-violet-400 bg-clip-text text-transparent">Services</span>
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-xl text-gray-300 leading-relaxed max-w-[750px] mx-auto">
              Comprehensive solutions spanning business consulting, digital innovation, and decentralized infrastructure to power your success.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 hover:border-blue-500/50 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className={`w-16 h-16 flex items-center justify-center border-2 ${service.color === 'blue' ? 'border-blue-400' : 'border-violet-400'} rounded-2xl mb-6 bg-transparent`}>
                <i className={`${service.icon} text-2xl ${service.color === 'blue' ? 'text-blue-400' : 'text-violet-400'}`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-gray-300 mb-6 leading-relaxed max-w-[750px]">{service.description}</p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-400">
                    <div className="w-4 h-4 flex items-center justify-center border border-blue-400 rounded-full mr-3 flex-shrink-0 bg-transparent">
                      <i className="ri-check-line text-blue-400 text-xs"></i>
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-2xl border border-gray-700/50 max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">Ready to Transform Your Business?</h3>
            <p className="text-xl text-gray-300 mb-8 max-w-[750px] mx-auto">
              Let's discuss how our comprehensive solutions can accelerate your growth and secure your digital future.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-gradient-to-r from-blue-600 to-violet-600 text-white px-8 py-4 rounded-full font-semibold hover:from-blue-700 hover:to-violet-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-right-line mr-2"></i>
              Get Started Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}